// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__12yj0","select":"Header_select__2KJ9Z","clinic":"Header_clinic__ot-Ze"};